export const LANGUAGES = ["en", "fr", "iu"] as const;
export type Language = (typeof LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = "en";

/**
 * The supported language for an i18next code such as `fr-CA`. Use this rather
 * than `resolvedLanguage`, which reports `en` while a language has no strings.
 */
export const toLanguage = (code?: string): Language =>
  LANGUAGES.find((language) => code?.startsWith(language)) ?? DEFAULT_LANGUAGE;

/** Each language in its own name, for the switcher. */
export const LANGUAGE_NAMES: Record<Language, string> = {
  en: "English",
  fr: "Français",
  iu: "ᐃᓄᒃᑎᑐᑦ",
};

/** Short code shown on the switcher button. */
export const LANGUAGE_CODES: Record<Language, string> = {
  en: "EN",
  fr: "FR",
  iu: "ᐃᓄ",
};

// Browsers ship little `iu` date/number data, so Inuktitut formats as en-CA.
export const INTL_LOCALES: Record<Language, string> = {
  en: "en-CA",
  fr: "fr-CA",
  iu: "en-CA",
};

// Add a namespace here, then create `en/<ns>.json` and its `fr`/`iu` copies.
export const NAMESPACES = [
  "common",
  "calculator",
  "dashboard",
  "quotes",
  "leads",
  "messages",
  "support",
  "validation",
  "profile",
  "account",
  "onboarding",
  "services",
  "meetings",
  "calendar",
  "estimator",
  "auth",
  "legal",
] as const;
export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_NAMESPACE: Namespace = "common";

export const LANGUAGE_STORAGE_KEY = "lng";
